import React from 'react';
import Routers from './router';
import intl from "react-intl-universal";
class App extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // document.title = intl.get('STAR_EXCHANGE');
    document.title='\u200E';
  }

  render() {
    return (
        <div style={{width: '100%', height: '100%', overflowX: 'hidden', overflowY: 'auto'}}>
          <Routers/>
        </div>
    );
  }
}


export default App;
